/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { TextLink } from '../TextLink';
import IconAdd from '../icons/IconAdd';

import IconProfile from '../icons/IconProfile';

const TextLinkWithIcon = (props) => {
  return (
    <TextLink onClick={props.onClick} colorClass="font-color-default">
      <div className={classnames('cmp-add-button-text-link', { 'util-application-frame-forcards-padding': !props.framePaddingDisabled }, props.className)}>
        {props.icon}
        <div style={{ marginLeft: 10 }}>
          {props.message}
        </div>
      </div>
    </TextLink>
  );
};
TextLinkWithIcon.propTypes = {
  icon: PropTypes.any,
  className: PropTypes.string,
  message: PropTypes.any,
  onClick: PropTypes.func,
  framePaddingDisabled: PropTypes.bool,
};

export const AddProfileTextLink = (props) => (
  <TextLinkWithIcon
    {...props}
    icon={<IconProfile.Small fillClassName="fill-color-profile-accent" strokeClassName="stroke-color-profile-accent" />}
  />
);

const AddButtonTextLink = (props) => (
  <TextLink onClick={props.onClick} colorClass="font-color-default">
    <div className={classnames('cmp-add-button-text-link', { 'util-application-frame-forcards-padding': !props.framePaddingDisabled }, props.className)}>
      <IconAdd fillClassName="fill-color-transparent" strokeClassName="stroke-color-profile" size="18" />
      <div style={{ marginLeft: 10 }}>
        <FormattedMessage id={props.messageId} />
      </div>
    </div>
  </TextLink>
);
AddButtonTextLink.propTypes = {
  className: PropTypes.string,
  messageId: PropTypes.string,
  onClick: PropTypes.func,
  framePaddingDisabled: PropTypes.bool,
};
AddButtonTextLink.defaultProps = {
  framePaddingDisabled: false,
};

export default AddButtonTextLink;
